import { REDUCE_PARAMETERS } from '../../constants/actions/policy';

export function reduceParameters(payload) {
    return {
        type: REDUCE_PARAMETERS,
        payload,
    };
}
